import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import { Eye, EyeOff } from 'lucide-react';
import { GoogleLogin } from '@react-oauth/google';

export default function CustomerLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, googleLogin } = useCustomerAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(email, password);
            navigate(from, { replace: true });
        } catch (err) {
            setError(err.response?.data?.error || 'Giriş yapılırken bir hata oluştu');
        }
        setLoading(false);
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        setError('');
        setLoading(true);
        try {
            const result = await googleLogin(credentialResponse.credential);
            if (result.profileIncomplete) {
                navigate('/profil-tamamla', { replace: true });
            } else {
                navigate(from, { replace: true });
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Google ile giriş yapılırken bir hata oluştu');
        }
        setLoading(false);
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-card-left">
                    <img src="/logo.svg" alt="Atölye Kirpi" className="auth-brand-logo" />
                    <p className="auth-brand-tagline">Zarafeti keşfedin</p>
                </div>
                <div className="auth-card-right">
                    <div className="auth-header">
                        <h1>Giriş Yap</h1>
                        <p>Hesabınıza giriş yaparak alışverişe devam edin</p>
                    </div>

                    {error && <div className="auth-error">{error}</div>}

                    <div className="auth-google-wrap">
                        <GoogleLogin
                            onSuccess={handleGoogleSuccess}
                            onError={() => setError('Google ile giriş başarısız oldu')}
                            text="signin_with"
                            shape="rectangular"
                            size="large"
                            width="100%"
                            locale="tr"
                        />
                    </div>

                    <div className="auth-divider">
                        <span>veya</span>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-form">
                        <div className="auth-field">
                            <label>E-posta</label>
                            <input
                                type="email"
                                placeholder="örnek@email.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="auth-field">
                            <label>Şifre</label>
                            <div className="auth-input-wrap">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Şifrenizi girin"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                />
                                <button type="button" className="auth-toggle-pw" onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                                </button>
                            </div>
                        </div>

                        <div className="auth-forgot">
                            <Link to="/sifremi-unuttum">Şifremi unuttum</Link>
                        </div>

                        <button type="submit" className="auth-submit" disabled={loading}>
                            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                        </button>
                    </form>

                    <div className="auth-footer">
                        Hesabınız yok mu? <Link to="/kayit">Üye Ol</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
